import { getBreakpoint, getHashProperty } from './_utils';

const headingTags = 'h1, h2, h3';
const containerClassName = 'AnchorLinks';
const linkClassName = `${containerClassName}-link`;
const linkClassNameSelector = `.${containerClassName}-link`;
const linkClassJsHook = `.${linkClassName}-js`;
const hiddenLinkClassName = `${containerClassName}-hidden`;
const hiddenLinkClass = `.${hiddenLinkClassName}`;
const largeNavClass = '.Navigation-lg';
const smallNavClass = '.Navigation-sm';
const addedLinkClass = 'AnchorLinks-added-link';

const paddingMap = {
	xlarge: 90,
	large: 70,
	medium: 60,
	small: 40,
};

export default function initAnchorLinks() {
	const hash = getHashProperty();
	//get all the h1 h2 or h3 on the page
	let allHeadings = $(headingTags);
	let lockBlocked = false;
	let allowUnlock = true;
	document.addEventListener('scroll', function (e) {
		if (lockBlocked && allowUnlock) {
			lockBlocked = false;
			window.dispatchEvent(new Event('allowLock'));
		}
	});
	//iterate through each child cta
	$(linkClassJsHook).each(function () {
		let link = $(this);
		let container = link.parent();
		//filter all the h2 by the text();
		let matchedHeadings = allHeadings.filter(function () {
			//switching to lower case so the text is case insensitive
			return $(this).text().trim().toLowerCase() === link.text().trim().toLowerCase();
		});
		//if there are matching elements, href to the first one otherwise hide the link
		if (matchedHeadings.length) {
			let match = matchedHeadings.first();

			//either get or set an id on the heading and update the href
			if (!match.attr('id')) {
				match.attr(
					'id',
					match
						.text()
						.trim()
						.toLowerCase()
						.replace(/[\s]/g, '_')
						.replace(/[\W]/g, match => match.charCodeAt(0))
				);
			}
			if (match.attr('id')) {
				// in case of link with no text matching heading with no text
				link.removeClass(addedLinkClass);
				link.attr('href', '#' + match.attr('id'));

				const scrollIntoView = () => {
					window.dispatchEvent(new Event('blockLock'));
					allowUnlock = false;
					lockBlocked = true;
					let isLargeNav = $(largeNavClass).is(':visible');

					//nav height and the padding for the given breakpoint
					let paddingNeeded =
						$(isLargeNav ? largeNavClass : smallNavClass).height() +
						paddingMap[getBreakpoint()];
					$('html, body').animate(
						{
							scrollTop: match.offset().top - paddingNeeded,
						},
						500,
						() => (allowUnlock = true)
					);

					//remove focus
					link.trigger('blur');
				};

				//attach a click listener to override default anchor "jump"
				link.on('click', function (e) {
					scrollIntoView();

					//track interaction, if needed
					if (link.data('event-name') === 'interaction') {
						window.FS.Tealium.trackInteraction(
							link.data('track-interaction_type'),
							link.data('track-interaction_name'),
							link.data('track-interaction_detail')
						);
					}

					return false;
				});
				if (hash === match.attr('id')) {
					// Due to a race condition for rendering DOM content, scroll on the URL hash must happen after page load.
					window.addEventListener(
						'load',
						() => {
							scrollIntoView();
						},
						{ once: true }
					);
				}
			}
		} else {
			if (container.length) {
				link.addClass(hiddenLinkClassName);

				//check if all the links in this container are hidden
				if (!container.find(linkClassJsHook).not(hiddenLinkClass).length) {
					//add hiddent to the container
					container.addClass(hiddenLinkClassName);
				}
			} else {
				link.css({ display: 'none' });
			}
		}
	});
	var $containers = $(`.${containerClassName}-container`);
	$containers.each(function () {
		const $container = $(this);
		// get how many links aren't hidden
		const childCount = $container.find(linkClassNameSelector).not(hiddenLinkClass).length;
		var newClass = 'AnchorLinks-container-' + childCount;
		//remove old class
		$container.removeClass(function (index, className) {
			return (className.match(/(^|\s)AnchorLinks-container-\S+/g) || []).join(' ');
		});
		// add the new class
		$container.addClass(newClass);
	});
}
